import React from 'react';
import * as moment from 'moment';
import { Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer';
import { stateConvert } from 'web/components/utils/stateAbbreviation';

const styles = StyleSheet.create({
  body: {
    paddingTop: 35,
    paddingBottom: 65,
    paddingHorizontal: 35,
    paddingLeft: 60,
    paddingRight: 60,

  },
  title: {
    fontSize: 22,
    textAlign: 'center',
    border: '1px solid #000',
    padding: 10,
    fontWeight: 'bold',
    marginBottom: 15,
  },

  subtitle: {
    fontSize: 14,
    marginTop: 10,
    marginBottom: 10,
    fontFamily: 'Helvetica-Bold'
  },
  text: {
    marginBottom: 10,
    fontSize: 12,
    textAlign: 'justify',
  },
});

const PdfDocument = props => (
  <>
    <Document>
      <Page style={styles.body}  >
        <Text style={styles.title}> Order Request </Text>
        <Text style={styles.subtitle}>Company Profile</Text>
        <Text style={styles.text}>Company Name : {props.pdfDocumentData?.addressDTO?.locationName}</Text>
        <Text style={styles.text}>Delivery Address : {props.pdfDocumentData?.addressDTO?.street}, {props.pdfDocumentData?.addressDTO?.city}, {stateConvert(props.pdfDocumentData?.addressDTO?.state?.trim()) || props.pdfDocumentData?.addressDTO?.state?.trim()},{props.pdfDocumentData?.addressDTO?.zipCode}</Text>
        <Text style={styles.subtitle}>Pallet Post Details </Text>
        <Text style={styles.text}>Order Reference # : {props.pdfDocumentData?.orderRefNumber}</Text>
        <Text style={styles.text}>Material : {props.pdfDocumentData?.palletDetails?.material || 'NA'}</Text>
        <Text style={styles.text}>Condition : {props.pdfDocumentData?.palletDetails?.condition?.toString()?.replaceAll(",", ", ") || 'NA'}{props.pdfDocumentData?.palletDetails?.newConditionType === 'HARDWOOD' ? '(HW)' : props.pdfDocumentData?.palletDetails?.newConditionType === 'SOFTWOOD' ? '(SW)' : ''}</Text>
        <Text style={styles.text}>Pallet Type : {props.pdfDocumentData?.palletDetails?.palletType || 'NA'}</Text>
        <Text style={styles.text}>Moisture : {props.pdfDocumentData?.palletDetails?.moisture || 'NA'}</Text>
        <Text style={styles.text}>Size : {(props.pdfDocumentData?.palletDetails?.size && props.pdfDocumentData?.palletDetails?.size !== '') ? props.pdfDocumentData?.palletDetails?.size :
          (props.pdfDocumentData?.palletDetails?.length && props.pdfDocumentData?.palletDetails?.length !== '') ? `${props.pdfDocumentData?.palletDetails?.length}x${props.pdfDocumentData?.palletDetails?.width}x${props.pdfDocumentData?.palletDetails?.height}` :
            'NA'
        }</Text>
        <Text style={styles.text}>Grade : {props.pdfDocumentData?.palletDetails?.grade || 'NA'}</Text>
        <Text style={styles.text}>Equipment : {props.equipmentRequirements}</Text>
        <Text style={styles.text}>RDD & Appt :
          {" "} {moment(props.pdfDocumentData?.requestDeliveryDate).format('MM/DD/YYYY')} & {" "}
          {props.pdfDocumentData?.deliveryFromTime} - {props.pdfDocumentData?.deliveryToTime ? props.pdfDocumentData?.deliveryToTime : "05:00"}
        </Text>
        <Text style={styles.subtitle}>Price & Quantity Details  </Text>
        <Text style={styles.text}>No. of Lot : {props.pdfDocumentData?.quantityDetails?.lots}</Text>
        <Text style={styles.text}>Quantity : {props.pdfDocumentData?.quantityDetails?.quantity}</Text>
        <Text style={styles.text}>Target Price : NA</Text>
        <Text style={styles.text}>Co packer Po# : {props.pdfDocumentData?.poNumber}</Text>
        <Text><Text style={styles.subtitle}>Load Comments : </Text> <Text style={styles.text}>{props.pdfDocumentData?.comment}</Text></Text>
      </Page>
    </Document>
  </>
);

export default PdfDocument;

